import Login from "../Login/Login";
import Logo from "../../assets/images/Effikit.png";
import UserImg from "../../assets/images/user-pic.png";
import WorkspaceLogo from "../../assets/images/workspace-logo.png";
import { Outlet, Link } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import {
  getDesignationsList,
  getPermissionsList,
  getRolesList,
} from "../../helpers/getPermission";
import { Dropdown } from "primereact/dropdown";
import DefaultImage from "../../profile_images/DefaultImage";

const setTitleClass = (
  title: string,
  setTitle: React.Dispatch<React.SetStateAction<string>>,
  iconclass: string,
  setIconClass: React.Dispatch<React.SetStateAction<string>>,
  icons: string,
  setIcon: React.Dispatch<React.SetStateAction<string>>,
  divClass: string,
  setDivClass: React.Dispatch<React.SetStateAction<string>>
) => {
  setTitle(title);
  setIconClass(iconclass);
  setIcon(icons);
  setDivClass(divClass);
};

const SideMenubar = ({
  title,
  priorityView,
  setTitle,
  setIcon,
  setIconClass,
  setDivClass,
}: {
  title: string;
  priorityView: boolean;
  setTitle: React.Dispatch<React.SetStateAction<string>>;
  setIcon: React.Dispatch<React.SetStateAction<string>>;
  setIconClass: React.Dispatch<React.SetStateAction<string>>;
  setDivClass: React.Dispatch<React.SetStateAction<string>>;
}) => {
  return (
    <div className="side-bar">
      <div className="d-flex logo-block">
        <img src={Logo} alt="" />
      </div>
      <div className="menu-block">
        <div className="project-section">
          <div className="d-flex menu-topic">
            <p>projects</p>
          </div>
          <div className="menu-items">
            <ul>
              <li className="m-l-item">
                {/* <Link to="logtime" 
                            onClick={() => setTitleClass('Log Time', setTitle,
                                'material-icons-outlined', setIconClass, 'timer', setIcon, 'lg-cl', setDivClass)}
                                >
                                <div className="d-flex lg-cl" >
                                    <span className="materi65al-icons-outlined">timer</span>
                                    <p>Log Time</p>
                                </div>
                            </Link> */}
              </li>
              {/* --------------------------------the below log time need to uncomment ------------------------------------------------- */}
              {/* <li className="m-l-item">
                <Link
                  to="logTime"
                  onClick={() =>
                    setTitleClass(
                      "LogTime",
                      setTitle,
                      "material-icons-outlined",
                      setIconClass,
                      "timer",
                      setIcon,
                      "logTime-cl",
                      setDivClass
                    )
                  }
                >
                  <div className="d-flex prty-cl">
                    <span className="material-icons-outlined">timer</span>
                    <p>Log Time</p>
                  </div>
                </Link>
              </li> */}
              <li className="m-l-item">
                <Link
                  to="priority"
                  onClick={() =>
                    setTitleClass(
                      "Priorities",
                      setTitle,
                      "material-icons-outlined",
                      setIconClass,
                      "library_add_check",
                      setIcon,
                      "prty-cl",
                      setDivClass
                    )
                  }
                >
                  <div className="d-flex prty-cl">
                    <span className="material-icons-outlined">
                      library_add_check
                    </span>
                    <p>Priorities</p>
                  </div>
                </Link>
              </li>
              <li className="m-l-item">
                <Link
                  to="task"
                  onClick={() =>
                    setTitleClass(
                      "Tasks",
                      setTitle,
                      "material-icons-round",
                      setIconClass,
                      "done_outline",
                      setIcon,
                      "task-cl",
                      setDivClass
                    )
                  }
                >
                  <div className="d-flex task-cl">
                    <span className="material-icons-round">done_outline</span>
                    <p>Tasks</p>
                  </div>
                </Link>
              </li>
              <li className="m-l-item">
                {/* <Link to="sprint" 
                            onClick={() => setTitleClass('Sprints', setTitle,
                                'material-icons-round', setIconClass, 'directions_run', setIcon, 'sp-cl', setDivClass)}
                                >
                                <div className="d-flex sp-cl">
                                    <span className="material-icons-round">directions_run</span><p>Sprints</p>
                                </div>
                            </Link> */}
              </li>
              <li className="m-l-item">
                <Link
                  to="report"
                  onClick={() =>
                    setTitleClass(
                      "Reports",
                      setTitle,
                      "material-icons-round",
                      setIconClass,
                      "insert_chart",
                      setIcon,
                      "rep-cl",
                      setDivClass
                    )
                  }
                >
                  <div className="d-flex rep-cl">
                    <span className="material-icons-round">insert_chart</span>
                    <p>Reports</p>
                  </div>
                </Link>
              </li>

              <li className="m-l-item">
                  <Link
                    to="logtime"
                    onClick={() =>
                      setTitleClass(
                        "Logtime", // Update title for Logtime
                        setTitle,
                        "material-icons-round",
                        setIconClass,
                        "schedule", // Icon for Logtime (material design 'schedule')
                        setIcon,
                        "logtime-cl", // Update CSS class for Logtime
                        setDivClass
                      )
                    }
                  >
                    <div className="d-flex logtime-cl">
                      <span className="material-icons-round">schedule</span>
                      <p>Logtime</p>
                    </div>
                  </Link>
                </li>

            </ul>
          </div>
        </div>
        <div className="others-section">
          <div className="d-flex menu-topic">
            <p>others</p>
          </div>
          <div className="menu-items">
            <ul>
              <li className="m-l-item">
                <Link
                  to="team"
                  onClick={() =>
                    setTitleClass(
                      "Teams",
                      setTitle,
                      "material-icons-round",
                      setIconClass,
                      "people_outline",
                      setIcon,
                      "prty-cl",
                      setDivClass
                    )
                  }
                >
                  <div className="d-flex prty-cl">
                    <span className="material-icons-round">people_outline</span>
                    <p>Teams</p>
                  </div>
                </Link>
              </li>
              <li className="m-l-item">
                {/* <Link to="leave" onClick={() => setTitleClass('Leave', setTitle,
                                'material-icons-round', setIconClass, 'insert_invitation', setIcon, 'rep-cl', setDivClass)}>
                                <div className="d-flex">
                                    <span className="material-icons-round">insert_invitation</span><p>Leave</p>
                                </div>
                            </Link> */}
              </li>
              <li className="m-l-item">
                <Link
                  to="client"
                  onClick={() =>
                    setTitleClass(
                      "Clients",
                      setTitle,
                      "material-icons-outlined",
                      setIconClass,
                      "supervised_user_circle",
                      setIcon,
                      "rep-cl",
                      setDivClass
                    )
                  }
                >
                  <div className="d-flex">
                    <span className="material-icons-outlined">
                      supervised_user_circle
                    </span>
                    <p>Clients</p>
                  </div>
                </Link>
              </li>
              <li className="m-l-item">
                <Link
                  to="logs"
                  onClick={() =>
                    setTitleClass(
                      "Work Logs Entry",
                      setTitle,
                      "material-icons-outlined",
                      setIconClass,
                      "insert_chart",
                      setIcon,
                      "rep-cl",
                      setDivClass
                    )
                  }
                >
                  <div className="d-flex">
                    <span className="material-icons-outlined">
                      insert_chart
                    </span>
                    <p>Logs</p>
                  </div>
                </Link>
              </li>
              <li className="m-l-item">
                {/* <Link to="admin" onClick={() => setTitleClass('Admin', setTitle,
                                'material-icons-outlined', setIconClass, 'local_police', setIcon, 'rep-cl', setDivClass)}>
                                <div className="d-flex">
                                    <span className="material-icons-outlined">local_police</span><p>Admin</p>
                                </div>
                            </Link> */}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

const SignOutTopPanel = ({
  loginUser,
  designation,
  role,
  profilePic,
  title,
  icons,
  iconClass,
  divClass,
  history,
  signout,
}: {
  loginUser: string | undefined;
  designation: string | undefined;
  role: string | undefined;
  profilePic: string | undefined;
  divClass: string;
  title: string;
  icons: string;
  iconClass: string;
  history: any;
  signout: any;
}) => {
  // const altImg = "https://img.freepik.com/free-icon/man_318-233556.jpg"
  return (
    <div className="d-flex main-section">
      <div className="d-flex top-menu">
        <div className={`d-flex page-name ${divClass}`}>
          <span className={iconClass}>{icons}</span>
          <p>{title}</p>
        </div>
        <div className="top-menu-workspace-account d-flex">
          <div className="workspace-account-logo d-flex">
            <img src={WorkspaceLogo} className="img-fluid" alt="" />
          </div>
          <div className="d-flex user-profile">
            <div className="user-pic">
              {/* <img className="img-fluid" src={profilePic || altImg} alt="" /> */}
              <DefaultImage
                src={profilePic}
                alt=""
                className="img-fluid"
                letter={loginUser?.[0]}
              />
            </div>
            <div className="user-details">
              <p className="u-name">{loginUser}</p>
              <p className="u-desg">{designation}</p>
            </div>
            <div>
              <Dropdown
                value={null}
                onChange={(e) => {
                  if (e.value === "Logout") signout(() => history("/logout"));
                }}
                options={[{ label: "Logout", value: "Logout" }]}
                placeholder={""}
              />
            </div>
            {/* <button className=' btn-outline' onClick={() => { 
                            //signout(() => history('/logout')) 
                        }}>
                        <span className="material-icons-round" >expand_more</span>
                        </button> */}

            {/* <div className="dropdown-icon">
                        <div className="profile-drpdwn">
                            <div className="d-flex"><span className="material-icons-round">account_circle</span><p>Profile</p></div>
                            <div className="d-flex" onClick={() => { signout(() => history('/logout')) }}><span className="material-icons-round">logout</span><p>Logout</p></div>
                        </div>
                    </div> */}
          </div>
        </div>
      </div>
      <div className="main-body-section d-flex">
        <Outlet />
      </div>
    </div>
  );
};

function Layout({
  login,
  history,
  setLogin,
  signout,
}: {
  login: any;
  history: any;
  setLogin: any;
  signout: any;
}) {
  const [title, setTitle] = useState("Task");
  const [icons, setIcon] = useState("done_outline");
  const [iconClass, setIconClass] = useState("material-icons-round");
  const [divClass, setDivClass] = useState("task-cl");

  useEffect(() => {
    _getPermissions();
  }, []);

  const [loginUser, setLoginUser] = useState<string>();
  const [role, setRole] = useState<string>();
  const [profilePic, setProfilePic] = useState<string>();
  const [designation, setDesignation] = useState<string>();
  const [priorityView, setPriorityView] = useState<boolean>(false);
  const [user, setUser] = useState<string | undefined>(loginUser);
  useEffect(() => {
    setUser(loginUser);
  }, [loginUser]);
  const _getPermissions = async () => {
    let token = await getPermissionsList();

    let profile = token?.login_user?.profile;
    setPriorityView(token?.login_user?.isInMultipleProject);
    setLoginUser(profile?.first_name + " " + profile?.last_name);
    setDesignation(token?.login_user?.designation);
    setProfilePic(token?.login_user?.profilepic);
    setRole(token?.login_user?.role_name);
  };

  return (
    <>
      {login ? (
        <div className="d-flex">
          <SideMenubar
            title={title}
            priorityView={priorityView}
            setTitle={setTitle}
            setIcon={setIcon}
            setIconClass={setIconClass}
            setDivClass={setDivClass}
          />

          {user && (
            <SignOutTopPanel
              loginUser={user}
              designation={designation}
              role={role}
              profilePic={profilePic}
              title={title}
              icons={icons}
              iconClass={iconClass}
              divClass={divClass}
              history={history}
              signout={signout}
            />
          )}
        </div>
      ) : (
        <div className="main-body-section login-screen-wrap d-flex">
          <Login setLogin={setLogin} />
        </div>
      )}
    </>
  );
}

export default Layout;
